import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Minúsculas y sin tildes, para buscar títulos (31-10-2026): «accion»
 *  encuentra «Acción» y los enlaces sin eñe («pequena»), «pequeña». */
export function foldSearch(s: string): string {
  return s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}
